import { currentHost } from "@/config";
export default {
  // namespaced: true,
  state: {
    userAvatar: "",
    userName: ""
  },
  // getters是当state有变化的时候才触发
  getters: {
    defaultUserAvatar: state => {
      if (state.userAvatar && state.userAvatar.trim()) {
        let cavatar = (state.userAvatar.indexOf('shendutv') > -1 || state.userAvatar.indexOf('http') > -1) ? state.userAvatar : currentHost + state.userAvatar
        return cavatar
      } else {
        return require('@/assets/img/see-doctor-icon/1-3pingluntouxiang@2x.png')
      }
    }
  },
  mutations: {
    mutationAvatar: (state, val) => {
      state.userAvatar = val
      // if (val && val.trim()) {
      // }
    },
    mutationName: (state, val) => {
      if (val && val.trim()) {
        state.userName = val
      }
    }
  },
  actions: {
    actionAvatar: (context, val) => {
      context.commit('mutationAvatar', val)
    },
    actionName: (context, val) => {
      context.commit('mutationName', val)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/userStore/index.js